<template>
  <header
    class="bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800"
  >
    <div class="flex justify-between w-full py-2 px-4">
      <div class="flex items-center justify-center max-w-full min-w-[6.25rem]">
        <woot-sidemenu-icon />
        <h1
          class="m-0 text-xl text-slate-900 dark:text-slate-100 overflow-hidden whitespace-nowrap text-ellipsis my-0 mx-2"
        >
          {{ headerTitle }}
        </h1>
      </div>
      <div v-if="showSelect" class="min-w-[300px]">
        <multiselect
          :value="selected"
          :options="selectOptions"
          track-by="id"
          label="name"
          :multiple="false"
          :placeholder="$t('SCHEDULE.ADD.FORM.PROFESSIONAL.PLACEHOLDER')"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          class="no-margin"
          @blur="setSelect"
          @select="setSelect"
        >
          <template slot="noResult">
            {{ $t('FORMS.MULTISELECT.NO_RESULT') }}
          </template>
          <template slot="noOptions">
            {{ $t('FORMS.MULTISELECT.NO_OPTIONS') }}
          </template>
        </multiselect>
      </div>
      <div class="flex gap-2">
        <div
          v-if="!showSearch"
          class="max-w-[400px] min-w-[150px] flex items-center relative mx-2 search-wrap"
        >
          &nbsp;
        </div>
        <div
          v-if="showSearch"
          class="max-w-[400px] min-w-[150px] flex items-center relative mx-2 search-wrap"
        >
          <div class="flex items-center absolute h-full left-2.5">
            <fluent-icon
              icon="search"
              class="h-5 leading-9 text-sm text-slate-700 dark:text-slate-200"
            />
          </div>
          <input
            type="text"
            :placeholder="placeholderSearch"
            class="contact-search border-slate-100 dark:border-slate-600"
            :value="searchQuery"
            @keyup.enter="submitSearch"
            @input="inputSearch"
          />
          <woot-button
            :is-loading="false"
            class="clear"
            :class-names="searchButtonClass"
            @click="submitSearch"
          >
            {{ $t('CONTACTS_PAGE.SEARCH_BUTTON') }}
          </woot-button>
        </div>
        <!-- <woot-button
          class="clear"
          color-scheme="success"
          icon="person-add"
          data-testid="create-new-contact"
          @click="toggleCreate"
        >
          {{ $t('CAMPAIGN_MSG.ADD.TITLE') }}
        </woot-button> -->
        <woot-button
          v-if="showNewButton"
          color-scheme="success"
          icon="add-circle"
          data-testid="create-new-contact"
          @click="toggleCreate"
        >
          {{ titleButton }}
        </woot-button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';

export default {
  mixins: [adminMixin],
  props: {
    selectOptions: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: '',
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: '',
    },
    placeholderSearch: {
      type: String,
      default: '',
    },
    showNewButton: { type: Boolean, default: true },
    showSelect: { type: Boolean, default: false },
    titleButton: { type: String, required: true },
  },
  data() {
    return {
      showCreateModal: false,
      showImportModal: false,
      // selected: {},
    };
  },
  computed: {
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
    ...mapGetters({
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
    }),
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
  },
  watch: {
    // selected() {
    //   console.log('selected header ', this.selected);
    //   this.$emit('on-select', this.selected);
    // },
  },
  methods: {
    setSelect(valSelect) {
      this.$emit('on-select', valSelect);
    },
    toggleCreate() {
      this.$emit('on-open-add-popup');
    },
    submitSearch() {
      this.$emit('on-search-submit');
    },
    inputSearch(event) {
      this.$emit('on-input-search', event);
    },
    // inputSearch(event) {
    //   this.$emit('on-input-search', event);
    // },
  },
};
</script>

<style lang="scss" scoped>
.search-wrap {
  .contact-search {
    @apply pl-9 pr-[3.75rem] text-sm w-full h-[2.375rem] m-0;
  }

  .button {
    transition: transform 100ms linear;
    @apply ml-2 h-8 right-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible;
  }

  .button.show {
    @apply opacity-100 translate-x-0 visible;
  }
}
</style>
